import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

@Component({
  selector: 'mb-dynamic-container',
  templateUrl: './dynamic-container.component.html',
  styleUrls: ['./dynamic-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicContainerComponent implements OnInit {
  elRef = inject(ElementRef);
  private platformId = inject(PLATFORM_ID);

  private lastEmittedWidth = 0;
  private lastEmittedHeight = 0;
  private _observedWidths: number[] = [];
  @Input()
  set observedWidths(v: number[]) {
    this._observedWidths = v
      .map((_v) => {
        return _v || 1;
      })
      .sort((a, b) => a - b);
  }
  get observedWidths() {
    return this._observedWidths;
  }

  private _observedHeights: number[] = [];
  @Input()
  set observedHeights(v: number[]) {
    this._observedHeights = v
      .map((_v) => {
        return _v || 1;
      })
      .sort((a, b) => a - b);
  }
  get observedHeights() {
    return this._observedHeights;
  }

  @Output() widthChanged = new EventEmitter<number>();
  @Output() heightChanged = new EventEmitter<number>();

  checkWidth(width: number) {
    let currentWidth = 0;
    this.observedWidths.forEach((_width) => {
      currentWidth = _width <= width ? _width : currentWidth;
    });
    if (currentWidth !== this.lastEmittedWidth) {
      this.lastEmittedWidth = currentWidth;
      this.widthChanged.emit(currentWidth);
    }
  }
  checkHeight(height: number) {
    let currentHeight = 0;
    this.observedHeights.forEach((_width) => {
      currentHeight = _width <= height ? _width : currentHeight;
    });
    if (currentHeight !== this.lastEmittedHeight) {
      this.lastEmittedHeight = currentHeight;
      this.heightChanged.emit(currentHeight);
    }
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const resizeObserver = new (window.ResizeObserver || Polyfill)((entries: any) => {
      for (let entry of entries) {
        this.checkWidth(entry.contentRect.width);
        this.checkHeight(entry.contentRect.height);
      }
    });
    resizeObserver.observe(this.elRef.nativeElement);
    this.checkHeight(this.elRef.nativeElement.clientHeight);
    this.checkWidth(this.elRef.nativeElement.clientWidth);
  }
}
